import React, { useEffect, useState } from "react";
import { SocialIcon } from "react-social-icons";
import { Link } from "react-router-dom";

const GOOGLE_REVIEW_URL = "https://share.google/tNvreYgh8O9exhort";

const MobileMenu = ({ mobileMenuVisible, scrollToSection }) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className={`mobile-menu ${mobileMenuVisible ? "visible" : "hidden"}`}
      style={{ height: `${windowHeight}px` }}
    >
      <div className="mobile-menu-container">
        <h4
          className="mobile-menu-item"
          onClick={() => scrollToSection("about-us")}
        >
          ABOUT US
        </h4>
        <h4
          className="mobile-menu-item"
          onClick={() => scrollToSection("our-services")}
        >
          OUR SERVICES
        </h4>
        <h4
          className="mobile-menu-item"
          onClick={() => scrollToSection("reviews")}
        >
          REVIEWS
        </h4>
        <Link to="/contact" className="mobile-menu-item">
          <h4>CONTACT US</h4>
        </Link>
        <Link to="/blog" className="mobile-menu-item">
          <h4>UPDATES</h4>
        </Link>
        <div className="mobile-menu-item">
          <SocialIcon
            className="facebook-icon"
            url="https://www.facebook.com/brightonroofingspecialists"
            target="_blank"
            rel="noopener noreferrer"
            fgColor={"white"}
            bgColor={"#4390e8"}
            style={{ height: "4vh", width: "4vh" }}
          />
          <h4>SOCIALS</h4>
          <a
            className="google-wrapper"
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/Images/google-logo.png"
              alt="Google Reviews logo"
              className="google-logo"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;